import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL || '';

export interface ActiveCountResponse {
  count: number;
}

const activeCount = async (
  webinarId: string
): Promise<{ status: number; data: ActiveCountResponse }> => {
  try {
    const response = await axios.get<ActiveCountResponse>(
      `${HOSTAPI}/connection/activeCount`,
      {
        headers: { 'Content-Type': 'application/json' },
        params: { webinarId },
      }
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      data: error.response?.data || { count: 0 },
    };
  }
};

export default activeCount;
let attendeeCount = 0;  // store latest count globally

export const fetchAttendeeCount = async (meetingNumber:string) => {
  const { status, data } = await activeCount(meetingNumber);
  if (status === 200) {
    attendeeCount = data.count || 0;
    // console.log('Attendee count from API:', attendeeCount);
    updateUI(attendeeCount);
  }
}

// / Function to get the panelist count from the DOM
function getPanelistCount(): number {
  const tablist = document.querySelector('.participants-style') as HTMLElement;
  if(tablist){
    // Select the Panelists tab button with role="tab" and text starting with 'Panelists'
    const panelistButton = tablist.querySelectorAll('[role="tablist"] button')[0] as HTMLElement; // Type assertion
    if (panelistButton) {
      const text = panelistButton.textContent || '';
      // Extract number inside parentheses
      const match = text.match(/\((\d+)\)/);
      if (match) {
        // console.log('getPanelistCount', parseInt(match[1], 10));
        return parseInt(match[1], 10);
      }
    }
  }
  return 0;
}

function updateUI(attendeeCount: number) {
  const panelistCount = getPanelistCount();

  // Update Attendees tab text
  const tablist = document.querySelector('.participants-style');
  if (tablist) {
    const tabButtons = tablist.querySelectorAll('[role="tablist"] button');
    if (tabButtons.length > 1) {
      const attendeesButton = tabButtons[1] as HTMLElement;
      attendeesButton.textContent = `Attendees (${attendeeCount})`;
    }
  }

  // Update Participants header: hide original h6, add/update a <p>
  const headerContainer = document.querySelector<HTMLDivElement>('.participants-style [aria-label="header"]');
  if (headerContainer) {
    const h6 = headerContainer.querySelector<HTMLHeadingElement>('h6');
    if (h6) {
      // hide the Zoom-managed header
      h6.style.display = 'none';
    }

    // compute total
    const total = panelistCount + attendeeCount;

    // look for our custom <p>, or create it
    let customP = headerContainer.querySelector<HTMLParagraphElement>('p.custom-participants-count');
    if (!customP) {
      customP = document.createElement('p');
      customP.className = 'custom-participants-count';
      // place it right after the original h6
      if (h6 && h6.parentNode) {
        h6.insertAdjacentElement('afterend', customP);
      } else {
        headerContainer.appendChild(customP);
      }
    }

    // set our text
    customP.textContent = `Participants (${total})`;
  }
}

let intervalId: any;

function startIfPresent() {
  if (document.querySelector('[aria-label="Participants"]')) {
    if (!intervalId) {
      updateUI(attendeeCount);
      intervalId = setInterval(() => updateUI(attendeeCount), 10000);
    }
  } else {
    const observer = new MutationObserver((mutations, obs) => {
      if (document.querySelector('[aria-label="Participants"]')) {
        obs.disconnect();  // disconnect the observer instance, not mutations
        updateUI(attendeeCount);
        intervalId = setInterval(() => updateUI(attendeeCount), 10000);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

// startIfPresent();